<template>
  <div class="recharge_left capital_first">
    <el-card class="box-card" shadow="never">
      <div slot="header" class="clearfix">
        <span class="title">{{ $t('pc.myaccount.trading_inquiry') }}</span>
      </div>
      <el-tabs v-model="activeName"  stretch>
        <el-tab-pane :label="$t('pc.tradingquery.position_query')" name="all_depot">
          <el-table
            :data="all_depot"
            stripe
            size="mini"
            style="width: 100%">
            <el-table-column
              prop="name"
              align="center"
              :label="$t('pc.allhkstock.name')">
            </el-table-column>
            <el-table-column
              prop="code_new"
              align="center"
              :label="$t('pc.allhkstock.code')">
            </el-table-column>
            <el-table-column
              prop="direction"
              align="center"
              :label="$t('pc.tradingquery.trade_direction')">
            </el-table-column>
            <el-table-column
              prop="number"
              align="center"
              :label="$t('pc.tradingquery.total_position')">
            </el-table-column>
            <el-table-column
              prop="surplus"
              align="center"
              :label="$t('pc.tradingquery.available_sell_quantity')">
            </el-table-column>
            <el-table-column
              prop="frozen"
              align="center"
              :label="$t('pc.tradingquery.frozen_quantity')">
            </el-table-column>
            <el-table-column
              prop="newPrice"
              align="center"
              :label="$t('pc.tradingquery.current_price')">
            </el-table-column>
            <el-table-column
              prop="price"
              align="center"
              :label="$t('pc.tradingquery.cost_price')">
            </el-table-column>
            <el-table-column
              prop="profitPrice"
              align="center"
              :label="$t('pc.tradingquery.profit_loss_amount')">
            </el-table-column>
            <el-table-column
              prop="priceRatio"
              align="center"
              :label="$t('pc.tradingquery.profit_loss_ratio')">
              <template slot-scope="scope">
                <p>{{ scope.row.priceRatio }}%</p>
              </template>
            </el-table-column>
            <el-table-column
              prop="market"
              align="center"
              :label="$t('pc.strategynow.market_value_of_positions')">
            </el-table-column>
            <el-table-column
              prop="time"
              align="center"
              :label="$t('pc.tradingquery.opening_date')">
               <template slot-scope="scope">
                <p>{{ $getDeviceDate(scope.row.time) }}</p>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
        <el-tab-pane :label="$t('pc.tradingquery.cancellation_order_query')" name="all_cancel">
          <el-table
            :data="all_cancel"
            size="mini"
            stripe
            style="width: 100%">
            <el-table-column
              prop="name"
              align="center"
              :label="$t('pc.allhkstock.name')">
            </el-table-column>
            <el-table-column
              prop="code_new"
              align="center"
              :label="$t('pc.allhkstock.code')">
            </el-table-column>
            <el-table-column
              prop="direction"
              align="center"
              :label="$t('pc.tradingquery.trade_direction')">
            </el-table-column>
            <el-table-column
              prop="type"
              align="center"
              :label="$t('pc.tradingquery.order_direction')">
            </el-table-column>
            <el-table-column
            prop="deal"
            align="center"
            :label="$t('pc.tradingquery.order_price')">
              <template slot-scope="scope">
                <p>{{ scope.row.deal.toFixed(2) }}</p>
              </template>
            </el-table-column>
            <el-table-column
              prop="number"
              align="center"
              :label="$t('pc.tradingquery.order_quantity')">
            </el-table-column>
            <el-table-column
              prop="surplus"
              align="center"
              :label="$t('pc.tradingquery.unfilled_quantity')">
            </el-table-column>
            <el-table-column
              prop="status"
              align="center"
              :label="$t('pc.tradingquery.order_status')">
            </el-table-column>
            <el-table-column
              prop="time"
              align="center"
              :label="$t('pc.tradingquery.order_time')">
              <template slot-scope="scope">
                <p>{{ $getDeviceDate(scope.row.time) }}</p>
              </template>
            </el-table-column>
            </el-table-column>
            <el-table-column
              :label="$t('pc.trading.operate')"
              align="center">
              <template slot-scope="scope">
                <el-button
                  size="mini"
                  type="danger"
                  @click="handleDelete(scope.row)">{{ $t('pc.trading.cancel_order') }}</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
        <el-tab-pane :label="$t('pc.trading.entrusted_query')" name="entrust">
        <el-form :inline="true" size="mini">
          <el-form-item :label="$t('pc.tradingquery.order_date')">
            <el-date-picker
              v-model="entrustData.date"
              type="daterange"
              value-format="yyyy-MM-dd"
              :range-separator="$t('pc.myaccount.to')"
              :start-placeholder="$t('pc.myaccount.start_date')"
              :end-placeholder="$t('pc.myaccount.end_date')">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="getEntrust">{{ $t('pc.trading.query') }}</el-button>
          </el-form-item>

        </el-form>
        <el-table
          :data="entrustData.entrust"
          size="mini"
          stripe
          style="width: 100%">
          <el-table-column
            prop="name"
            align="center"
            :label="$t('pc.allhkstock.name')">
          </el-table-column>
          <el-table-column
            prop="code_new"
            align="center"
            :label="$t('pc.allhkstock.code')">
          </el-table-column>
          <el-table-column
            align="center"
            :label="$t('pc.trading.direction')+'/'+$t('pc.trading.open_position')">
            <template slot-scope="scope">
              <p>{{ scope.row.direction }}</p>
              <p>{{ scope.row.position_open_close }}</p>
            </template>
          </el-table-column>
          <el-table-column
            prop="deal"
            align="center"
            :label="$t('pc.tradingquery.order_price')">
          </el-table-column>
          <el-table-column
            prop="price"
            align="center"
            :label="$t('pc.trading.transaction_sold_price')">
          </el-table-column>
          <el-table-column
            prop="number"
            align="center"
            :label="$t('pc.tradingquery.order_quantity')">
          </el-table-column>
          <el-table-column
            prop="finish"
            align="center"
            :label="$t('pc.trading.transaction_quantity')">
          </el-table-column>
          <el-table-column
            align="center"
            :label="$t('pc.trading.business')+'/'+$t('pc.trading.order')">
            <template slot-scope="scope">
                <p>{{ scope.row.trade_type }}</p>
                <p>{{ scope.row.order_type }}</p>
            </template>
          </el-table-column>
          <el-table-column
            prop="status"
            align="center"
            :label="$t('pc.trading.status')">
          </el-table-column>
          <el-table-column
            prop="accurate"
            align="center"
            width="150"
            :label="$t('pc.tradingquery.order_time')">
            <template slot-scope="scope">
              
              <p>{{ $getDeviceTime(scope.row.time) }}</p>
            </template>
          </el-table-column>
          <el-table-column
            prop="complete_time"
            align="center"
            width="150"
            :label="$t('pc.tradingquery.transaction_time')">
              <template slot-scope="scope">
              <p v-if="scope.row.complete_time!=''">{{ $getDeviceTime(scope.row.complete_time) }} </p>
            </template>
          </el-table-column>
        </el-table>
        <div class="changePage">
          <el-button type="primary" icon="el-icon-arrow-left" @click="prevEntrust" size="mini">{{ $t('pc.myaccount.previous_page') }}</el-button>
          <el-button type="primary" icon="el-icon-arrow-right" @click="nextEntrust" size="mini" style="float: right">{{ $t('pc.myaccount.next_page') }}</el-button>
        </div>

      </el-tab-pane>
        <el-tab-pane :label="$t('pc.tradingquery.transaction_inquiry')" name="deal">
          <el-form :inline="true" size="mini">
            <el-form-item :label="$t('pc.tradingquery.order_date')">
              <el-date-picker
                v-model="dealData.date"
                type="daterange"
                value-format="yyyy-MM-dd"
                :range-separator="$t('pc.myaccount.to')"
                :start-placeholder="$t('pc.myaccount.start_date')"
                :end-placeholder="$t('pc.myaccount.end_date')">
              </el-date-picker>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="getDeal">{{ $t('pc.trading.query') }}</el-button>
            </el-form-item>
            <el-form-item>
              {{ $t('pc.tradingquery.buy_amount') }}¥:{{ totalbuy.toFixed(2) }}
            </el-form-item>
          </el-form>
          <el-table
            :data="dealData.deal"
            size="mini"
            stripe
            style="width: 100%">
            <el-table-column
              prop="name"
              align="center"
              :label="$t('pc.allhkstock.name')">
            </el-table-column>
            <el-table-column
              prop="code_new"
              align="center"
              :label="$t('pc.allhkstock.code')">
            </el-table-column>
            <el-table-column
              align="center"
              :label="$t('pc.trading.direction')+'/'+$t('pc.trading.open_position')">
              <template slot-scope="scope">
                <p>{{ scope.row.direction }}</p>
                <p>{{ scope.row.position_open_close }}</p>
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              :label="$t('pc.trading.business')+'/'+$t('pc.trading.order')">
              <template slot-scope="scope">
                <p>{{ scope.row.trade_type }}</p>
                <p>{{ scope.row.order_type }}</p>
              </template>
            </el-table-column>
            <el-table-column
              prop="price"
              align="center"
              :label="$t('pc.trading.transaction_sold_price')">
            </el-table-column>
            <el-table-column
              prop="number"
              align="center"
              :label="$t('pc.trading.transaction_quantity')">
            </el-table-column>
            <el-table-column
              prop="total"
              align="center"
              :label="$t('pc.trading.transaction_amount')">
            </el-table-column>
            <el-table-column
              prop="commission"
              align="center"
              :label="$t('pc.tradingquery.commission')">
            </el-table-column>
            <el-table-column
              prop="stamp"
              align="center"
              :label="$t('pc.trading.stamp_duty')">
            </el-table-column>
            <el-table-column
              prop="change"
              align="center"
              :label="$t('pc.tradingquery.transaction_levy')">
            </el-table-column>
            <el-table-column
              prop="extra_fee1"
              align="center"
              :label="$t('pc.tradingquery.transaction_fee')">
            </el-table-column>
            <el-table-column
              prop="extra_fee2"
              align="center"
              :label="$t('pc.tradingquery.settlement_and_settlement_fee')">
            </el-table-column>
            <el-table-column
              prop="extra_fee3"
              align="center"
              :label="$t('pc.tradingquery.platform_fee')">
            </el-table-column>
            <el-table-column
              prop="transaction"
              align="center"
              :label="$t('pc.trading.trading_activity_fee')">
            </el-table-column>
            <el-table-column
              prop="chj_levy"
              align="center"
              :label="$t('pc.trading.frc_transaction')">
            </el-table-column>
            <el-table-column
              prop="time"
              align="center"
              :label="$t('pc.tradingquery.transaction_time')"
              width="100">
            
              <template slot-scope="scope">
                <p>{{ $getDeviceTime(scope.row.time) }}</p>
                <!-- <p>{{ scope.row.accurate }}</p> -->
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
        <el-tab-pane :label="$t('pc.trading.system_closing_possition')" name="unwind">
          <el-table
            :data="unwindData"
            size="mini"
            stripe
            style="width: 100%">
            <el-table-column
              prop="name"
              align="center"
              :label="$t('pc.allhkstock.name')">
            </el-table-column>
            <el-table-column
              prop="code_new"
              align="center"
              :label="$t('pc.allhkstock.code')">
            </el-table-column>
            <el-table-column
              prop="direction"
              align="center"
              :label="$t('pc.tradingquery.trade_direction')">
            </el-table-column>
            <el-table-column
              align="center"
              :label="$t('pc.trading.business')+'/'+$t('pc.trading.order')">
              <template slot-scope="scope">
                <p>{{ scope.row.trade_type }}</p>
                <p>{{ scope.row.order_type }}</p>
              </template>
            </el-table-column>
            <el-table-column
              prop="number"
              align="center"
              :label="$t('pc.trading.transaction_quantity')">
            </el-table-column>
            <el-table-column
              prop="price"
              align="center"
              :label="$t('pc.trading.transaction_sold_price')">
            </el-table-column>
            <el-table-column
              prop="total"
              align="center"
              :label="$t('pc.trading.transaction_amount')">
            </el-table-column>
            <el-table-column
              prop="commission"
              align="center"
              :label="$t('pc.trading.broker_commission')">
            </el-table-column>
            <el-table-column
              prop="stamp"
              align="center"
              :label="$t('pc.trading.stamp_duty')">
            </el-table-column>
            <el-table-column
              prop="change"
              align="center"
              :label="$t('pc.trading.transfer_fee')">
            </el-table-column>
            <el-table-column
              prop="time"
              align="center"
              :label="$t('pc.tradingquery.transaction_time')">
              <template slot-scope="scope">
                <p>{{ $getDeviceTime(scope.row.time) }}</p>
                <!-- <p>{{ scope.row.accurate }}</p> -->
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
      </el-tabs>
    </el-card>
  </div>
</template>

<script>
    import $ from "jquery";

    export default {
      name: "tradingQuery",
      data(){
        return{
          source_return_data:[],
          activeName:'all_depot',
          all_depot:[],
          all_cancel:[],
          entrustData:{
            date:[],
            entrust:[],
            page:1,
            num:20,
          },
          dealData:{
            date:[],
            deal:[],
          },
          unwindData:[],
          totalbuy:0,
          totalsell:0
        }
      },
      methods:{
        getAllDepot() {
          let that = this;
          that.$http({
              url: "/",
              method: "post",
              data: {
                nozzle: 'all_depot',
                token: window.sessionStorage.getItem('token'),
              }
            })
            .then(function(res) {
              let resData = res.data;
              if (resData.code == 1) {
                let dataArr = resData.data;
                if (dataArr.length != 0){
                  let shortArr = [];
                  $.each(dataArr, function(index, item) {
                    shortArr.push(item.short);
                  });
                  that.getPrice(shortArr,dataArr);
                }else{
                  that.all_depot = resData.data;
                }
              } else if (resData.code == 0 || resData.code == -1) {
                that.$message.error(that.$t(that.$t(res.data.msg)));
              }
            });
        },
        getAllCancel(){
          let that = this;
          that.$http({
            url: "/",
            method: "post",
            data: {
              nozzle: 'all_cancel',
              token: window.sessionStorage.getItem('token'),
            }
          })
            .then(function(res) {
              let resData = res.data;
              if (resData.code == 1) {
                that.all_cancel = resData.data;
              } else if (resData.code == 0 || resData.code == -1) {
                that.$message.error(that.$t(that.$t(res.data.msg)));
              }
            });
        },
        getEntrust(){
          let that = this;
          let data = {
    nozzle: 'all_entrust',
    token: window.sessionStorage.getItem('token'),
    page: that.entrustData.page,
    num: that.entrustData.num
  };

  if (that.entrustData.date[0]) {
    data.start = that.$moment(that.entrustData.date[0])
      .startOf('day')
      .utc()
      .format('YYYY-MM-DD HH:mm:ss');
  }
  if (that.entrustData.date[1]) {
    data.end = that.$moment(that.entrustData.date[1])
      .endOf('day')
      .utc()
      .format('YYYY-MM-DD HH:mm:ss');
  }
          that.$http({
            url: "/",
            method: "post",
            data: data,
          })
          
            .then(function(res) {
              let resData = res.data;
              if (resData.code == 1) {
                let entrust = resData.data;
                // let unwindData = [];
                for (let i = 0,len = entrust.length;i < len; i++){
                  if (entrust[i].depot_mold === 1){
                    // unwindData.push(entrust[i])

                  }
                }
                // that.unwindData = unwindData;
                that.entrustData.entrust = entrust;
              } else if (resData.code == 0 || resData.code == -1) {
                that.$message.error(that.$t(that.$t(res.data.msg)));
              }
            });
        },
        getUnwindData(){
          let that = this;
          that.$http({
            url: "/",
            method: "post",
            data: {
              nozzle: 'all_deal',
              token: window.sessionStorage.getItem('token'),
            }
          })
            .then(function(res) {
              let resData = res.data;
              if (resData.code == 1) {
                let entrust = resData.data;
                let unwindData = [];
                for (let i = 0,len = entrust.length;i < len; i++){
                  if (entrust[i].depot_mold === 1){
                    unwindData.push(entrust[i])
                    that.totalbuy = that.totalbuy + parseFloat(entrust[i].total)
                  }else{
                    that.totalsell = that.totalsell + parseFloat(entrust[i].total)
                  }
                }
                that.unwindData = unwindData;
              } else if (resData.code == 0 || resData.code == -1) {
                that.$message.error(that.$t(that.$t(res.data.msg)));
              }
            });

        },
        getDeal(){
          let that = this;
            let data = {
    nozzle: 'all_deal',
    token: window.sessionStorage.getItem('token'),
  };

  if (that.dealData.date[0]) {
    data.start = that.$moment(that.dealData.date[0])
      .startOf('day')
      .utc()
      .format('YYYY-MM-DD HH:mm:ss');
  }
  if (that.dealData.date[1]) {
    data.end = that.$moment(that.dealData.date[1])
      .endOf('day')
      .utc()
      .format('YYYY-MM-DD HH:mm:ss');
  }
          that.$http({
            url: "/",
            method: "post",
            data:data
          })
            .then(function(res) {
              let resData = res.data;
              if (resData.code == 1) {
                that.dealData.deal = resData.data;
              } else if (resData.code == 0 || resData.code == -1) {
                that.$message.error(that.$t(that.$t(res.data.msg)));
              }
            });
        },
        prevEntrust(){
          let page = this.entrustData.page;
          if (page == 1){
            this.$message({
              message:  this.$t('pc.timebao.first_page'),
              type: 'warning'
            });
          }else{
            this.entrustData.page = page-1;
            this.getEntrust();
          }
        },
        nextEntrust(){
          let page = this.entrustData.page;
          if ( this.entrustData.entrust.length < 20){
            this.$message({
              message:  this.$t('pc.timebao.last_page'),
              type: 'warning'
            });
          }else{
            this.entrustData.page = page+1;
            this.getEntrust();
          }
        },
        handleDelete(data){
          let that = this;
          that.$http({
            url: "/",
            method: "post",
            data: {
              nozzle: "cancel_entrust",
              token: sessionStorage.getItem("token"),
              'cid': data.cid,
              order: data.id
            }
          })
            .then(function(res) {
              if (res.data.code == 1) {
                that.$message({
                  message: that.$t(that.$t(res.data.msg)),
                  type: "success",
                  duration: 1000,
                  onClose:function () {
                    that.getAllCancel();
                  }
                });
              } else if (res.data.code == 0 || res.data.code == -1) {
                that.$message.error(that.$t(that.$t(res.data.msg)));
              }
            });
        },
        getPrice(shortArr, dataArr) {
          let that = this;
          let data = that.getFromShuhai(shortArr.toString(), true,shortArr, dataArr);
          // $.ajax({
          //   url: "https://qt.gtimg.cn/q=" + shortArr.toString(),
          //   type: "GET",
          //   dataType: "script",
          //   cache: true,
          //   success: function() {
          //     var i, elements;
          //     for (i = 0; i < shortArr.length; i++) {
          //       var elements = eval("v_" + shortArr[i]).split("~");
          //       dataArr[i]["newPrice"] = elements[3]; //当前价
          //       var newPrice = parseFloat(elements[3]); //当前价
          //       var number = parseFloat(dataArr[i].number); //持有股数
          //       var costPrice = parseFloat(dataArr[i].price); //成本价
          //       var profitPrice = Number((newPrice - costPrice).toFixed(2)); //盈亏金额
          //       var priceRatio = ((newPrice - costPrice) / costPrice) * 100; //盈亏比例
          //       var market = (newPrice * number).toFixed(2); //当前市值
          //       priceRatio = priceRatio.toFixed(2);
          //       dataArr[i]["profitPrice"] = profitPrice;
          //       dataArr[i]["priceRatio"] = priceRatio;
          //       dataArr[i]["market"] = market;
          //     }
          //     that.all_depot = dataArr
          //   }
          // });
        },
         getNewPrice(shortArr, dataArr) {
          let that = this;
            var i, elements;
            for (i = 0; i < shortArr.length; i++) {
              dataArr[i]["newPrice"] = that.source_return_data[i].NewPrice; //当前价
            }

          for (i = 0; i < shortArr.length; i++) {
            var newPrice = parseFloat(dataArr[i]["newPrice"]); //当前价
            var number = parseFloat(dataArr[i].number); //持有股数
            var costPrice = parseFloat(dataArr[i].price); //成本价
            var profitPrice = Number((newPrice - costPrice).toFixed(2)); //盈亏金额
            var priceRatio = ((newPrice - costPrice) / costPrice) * 100; //盈亏比例
            var market = (newPrice * number).toFixed(2); //当前市值
            priceRatio = priceRatio.toFixed(2);
            dataArr[i]["profitPrice"] = profitPrice;
            dataArr[i]["priceRatio"] = priceRatio;
            dataArr[i]["market"] = market;
          }
          that.all_depot = dataArr
        },
        getFromShuhai(objectElement, return_data = false, shortArr, dataArr) {
          let that = this;
          that
            .$http({
              url: "/",
              method: "post",
              data: {
                nozzle: "shuhai_price",
                code: (return_data?objectElement:objectElement.info.toString()),
                withcode: 0,
              },       
            })
            .then(function (res) {
              if (res.data.code == 1) {
                if (return_data){
                  that.source_return_data = res.data.data;
                  that.getNewPrice(shortArr, dataArr);
                  return;
                };
              } 
            });
        },
      },
      mounted(){
        this.getAllDepot();
        this.getAllCancel();
        this.getUnwindData();
        this.getDeal();
        this.getEntrust();
      },

    }
</script>

<style scoped>
  .changePage{
    margin-top: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/tradingQuery.vue